import { render, staticRenderFns } from "./RewardExpiration.vue?vue&type=template&id=52016340&"
import script from "./RewardExpiration.vue?vue&type=script&lang=js&"
export * from "./RewardExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports